import React from "react";
import { useTranslation } from "react-i18next";

import { parseAndLinkify } from "@components/Utils";

export function ModeratorCommentsForDeveloper({ moderationFields }) {
    const { t } = useTranslation();

    if (!moderationFields || !moderationFields.fields || moderationFields.fields.length === 0) {
        return null;
    }

    return (
        <div className="dmg-callout dmg-callout-danger">
            <div className="mb-2">{t("Комментарии модератора")}</div>
            {moderationFields.fields.map((field, index) => (
                <div key={index}>
                    <a href={field.url}>{field.label}</a>:{" "}
                    <span className="show-wrap-text">{parseAndLinkify(field.comment)}</span>
                </div>
            ))}
        </div>
    );
}
